'use client';

import React from 'react';

import Icon from '@/components/ui/AppIcon';

const services = [
  {
    icon: 'BuildingLibraryIcon',
    title: 'Свайно-ростверковый фундамент',
    description:
      'Конструкция из заглубленных ниже промерзания свай, объединенных сверху общей бетонной лентой или плитой (ростверком)',
  },
  {
    icon: 'BuildingLibraryIcon',
    title: 'Плитный фундамент',
    description:
      'Монолитная железобетонная плита, возводимая под всей площадью здания. Она обеспечивает высокую несущую способность на слабых и пучинистых грунтах, защищает от грунтовых вод и может служить основанием для пола.',
  },
  {
    icon: 'CubeIcon',
    title: 'Перекрытия',
    description: 'Прочные бетонные перекрытия для многоэтажного строительства',
  },
];

export default function ServicesSection() {
  return (
    <section
      id="services"
      className="bg-background px-4 py-16 sm:px-6 sm:py-20"
    >
      <div className="mx-auto max-w-7xl">
        <h2 className="mb-3 text-3xl font-bold text-foreground sm:text-4xl md:text-5xl">
          Что мы делаем
        </h2>

        <p className="mb-10 max-w-2xl text-base text-muted-foreground sm:mb-12 sm:text-lg">
          Полный спектр профессиональных бетонных работ для частных
          застройщиков.
        </p>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 sm:gap-6 lg:grid-cols-6">
          {services.map((service, i) => (
            <div
              key={i}
              className="rounded-xl border border-border bg-card p-5 transition-shadow duration-300 hover:shadow-lg sm:p-6 lg:col-span-2"
            >
              <Icon
                name={service.icon as Parameters<typeof Icon>[0]['name']}
                size={32}
                className="mb-4 text-primary"
              />

              <h3 className="mb-2 text-lg font-semibold text-foreground sm:text-xl">
                {service.title}
              </h3>

              <p className="text-sm text-muted-foreground">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}